const map = {
	"./discover-shostakovich-timeless-music-legacy.jsx": [
		7947,
		[
			947
		]
	],
	"./how-mozart-changed-classical-music.jsx": [
		1475,
		[
			475
		]
	],
	"./johann-sebastian-bach-life-works-legacy.jsx": [
		7080,
		[
			80
		]
	],
	"./the-periods-of-western-classical-era-mumbai.jsx": [
		7364,
		[
			364
		]
	],
	"./top-10-facts-about-beethoven.jsx": [
		2410,
		[
			410
		]
	],
	"./why-chopins-music-still-inspires.jsx": [
		2158,
		[
			158
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8811;
module.exports = webpackAsyncContext;